/*
 * @Author: Zhouqi
 * @Date: 2025-12-12 11:53:40
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-12 13:37:00
 */

import { createMenuList, MenuItem } from './useRouterMenu';

// 菜单骨架屏组件 - 基于真实菜单数据动态生成
const MenuSkeleton = () => {
  const menuData = createMenuList();

  const renderSkeletonItem = (item: MenuItem, index: number) => {
    if (item.type === 'group') {
      // 渲染分组
      return (
        <div key={index} className="mt-[16px]">
          {/* 分组标题 */}
          <div className="relative h-[12px] bg-gray-200 rounded-[4px] max-w-[70px] mb-[8px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
          {/* 分组子项 */}
          <div className="flex flex-col gap-[4px]">
            {item.children?.map((child, childIndex) => (
              <div
                key={childIndex}
                className="flex items-center gap-[12px] h-[48px] px-[12px]"
              >
                <div className="relative w-[24px] h-[24px] bg-gray-200 rounded-[4px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
                <div className="relative flex-1 h-[16px] bg-gray-200 rounded-[4px] max-w-[100px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    // 渲染普通菜单项
    return (
      <div key={index} className="flex items-center gap-[12px] h-[48px] px-[12px]">
        <div className="relative w-[24px] h-[24px] bg-gray-200 rounded-[4px] overflow-hidden">
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
        </div>
        <div className="relative flex-1 h-[16px] bg-gray-200 rounded-[4px] max-w-[80px] overflow-hidden">
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
        </div>
      </div>
    );
  };

  return (
    <>
      <style jsx>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
      <div className="flex flex-col gap-[8px] px-[16px] py-[12px]">
        {menuData.map((item, index) => renderSkeletonItem(item, index))}
      </div>
    </>
  );
};

export default MenuSkeleton;
